var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScienceFill0Wght400Grad0Opsz241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 31.5C6.225 31.5 5.31875 30.9313 4.78125 29.7938C4.24375 28.6562 4.375 27.6 5.175 26.625L13.5 16.5V7.5H12C11.575 7.5 11.2188 7.35625 10.9313 7.06875C10.6438 6.78125 10.5 6.425 10.5 6C10.5 5.575 10.6438 5.21875 10.9313 4.93125C11.2188 4.64375 11.575 4.5 12 4.5H24C24.425 4.5 24.7813 4.64375 25.0688 4.93125C25.3563 5.21875 25.5 5.575 25.5 6C25.5 6.425 25.3563 6.78125 25.0688 7.06875C24.7813 7.35625 24.425 7.5 24 7.5H22.5V16.5L30.825 26.625C31.625 27.6 31.7563 28.6562 31.2188 29.7938C30.6813 30.9313 29.775 31.5 28.5 31.5H7.5ZM7.5 28.5H28.5L19.5 17.55V7.5H16.5V17.55L7.5 28.5Z",
    fill: "#738395"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/science_FILL0_wght400_GRAD0_opsz24 1.698e3272bc3c39195db3d8ee491bd24d.svg";
export { ForwardRef as ReactComponent };